import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  environment } from '../../environments/environment';
import { QuestionGroup } from '../objects/interface-library';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {


  googleSheetId = environment['fieldValuesGoogleSheetId'];

  // BDA key = AIzaSyC-5gvjrj0vx82W30NwzAwXe6xLD2eOdVc
  bdaSheetsApiKey = 'AIzaSyC-5gvjrj0vx82W30NwzAwXe6xLD2eOdVc';

  httpOptions = {
    params : {
      'key' : this.bdaSheetsApiKey,
      'majorDimension': 'COLUMNS'
    },
    headers : {
      'Content-Type' : 'application/json'
    }
  }



  physicianEmploymentAgreementObject = {
    docId: '1NjCJOKp-86eqAIDYe87N5B57gGe2l4lRtYiFYDctybg',
    fileName: 'placeholder.docx',
    fileType: 'word',
    updateDocObject: null,
    org: environment.org
  }



  constructor(private http: HttpClient) { }




  async generateDocumentFromTemplate(workflowId, docUpdateMap): Promise<any> {

    // console.log('*** doc update map: ', docUpdateMap);
    // console.log('workflowID: ', workflowId);

    let datetimestamp = (new Date).getTime().toString();

    this.physicianEmploymentAgreementObject.fileName = workflowId + '-' + datetimestamp + '.docx';

    this.physicianEmploymentAgreementObject.updateDocObject = docUpdateMap;

    let response = await this.http.post(environment.workflowUrlGenerateDoc,
                                        JSON.stringify(this.physicianEmploymentAgreementObject),
                                        this.httpOptions).toPromise();

    return response;

  }



 
  async getStaticSheetQuestions(questionGroup): Promise<any> {

    const tabName = 'workflow-questions';
    let startCell = null;
    let endCell = null;

    switch (questionGroup) {
      case QuestionGroup.PhysicianEmploymentAgreement:

        startCell = 'A2';
        endCell = 'B25';
        
        break;

      default:

        console.warn('Question group NOT found: ', questionGroup);

        break;
    }


    const sheetUrl = 'https://sheets.googleapis.com/v4/spreadsheets/' +
                                this.googleSheetId +
                                '/values/' +
                                tabName +
                                '!' +
                                startCell +
                                ':' +
                                endCell;

    let response = await this.http.get(sheetUrl, this.httpOptions).toPromise();

    // Let me explain...we get a response from Google Sheet but it is an array per
    // column.  The 'values' is the json key.  I'm getting the length of the first
    // set of values so I can create key value pairs for the json I will return.
    // Array 0 is the question.  Array 1 is the type of control.

    if (response['values']) {

      let returnObject = {
        questions: response['values'][0],
        answerTypes: response['values'][1]
      };

      // response['values'][0].forEach(function (k, i) {
      //     returnObject[k] = response['values'][1][i];
      // })

      return returnObject;
    } else {
      return null;
    }

  }





  async getStaticSheetWorkflowColumn(workflowStaticSheetColumn): Promise<any> {

    const tabName = 'workflow';
    let startCell = null;
    let endCell = null;

    switch (workflowStaticSheetColumn) {
      case 'stateOfRecord':

        startCell = 'A2';
        endCell = 'A65';
        
        break;

      case 'transactionType':

        startCell = 'B2';
        endCell = 'B50';
      
        break;

      case 'documentType':

        startCell = 'C2';
        endCell = 'C50';
      
        break;

      case 'phase':

        startCell = 'D2';
        endCell = 'D25';
      
        break;

      case 'status':

          startCell = 'E2';
          endCell = 'E25';
        
          break;

      case 'valueThreshold':
        
        startCell = 'F2';
        endCell = 'F25';
      
        break;

      case 'priority':
        
          startCell = 'G2';
          endCell = 'G25';
        
          break;

      default:
        break;
    }


    const sheetUrl = 'https://sheets.googleapis.com/v4/spreadsheets/' +
                                this.googleSheetId +
                                '/values/' +
                                tabName +
                                '!' +
                                startCell +
                                ':' +
                                endCell;

    let response = await this.http.get(sheetUrl, this.httpOptions).toPromise();

    // console.log('workflow static fields - response: ', response);

    // let dataTableValues = response['values'][0];
    // dataTableValues.shift();

    if (response['values']) {
      return response['values'][0];
    } else {
      return null;
    }


  }




  async getDocumentList(entityId): Promise<any> {

    let options = {
                    headers : {
                                  'Content-Type' : 'application/json'
                              },
                    params :  {
                                'id' : entityId,
                              },
                  };
  

      let dbResponse = await this.http.get(environment.workflowUrlGetDocumentsForEntity + environment.org, options)
                                      .toPromise();

      // console.log('Document List dbResponse: ', dbResponse);

      return dbResponse;
  } 




  async createNewWorkflowRequest(newWorkflowRequest): Promise<any> {

    let options = {
                    headers : {
                                  'Content-Type' : 'application/json'
                              }
                  };
  
      let body = JSON.stringify(newWorkflowRequest);

      let dbResponse = await this.http.put(environment.workflowUrlNewRequest + environment.org, body, options)
                                      .toPromise();

      // console.log('getRequests dbResponse: ', dbResponse);

      return dbResponse;
  }


  async getRequests(status, entityType): Promise<any> {

    let options = {
                    headers : {
                                  'Content-Type' : 'application/json'
                              },
                    params :  {
                                'status' : status,
                                'entityType' : entityType
                              },
                  };
  

      let dbResponse = await this.http.get(environment.workflowUrlGetRequests + environment.org, options)
                                      .toPromise();

      // console.log('getRequests dbResponse: ', dbResponse);

      return dbResponse;
  }


  async getRequestByNum(workflowRequestNum): Promise<any> {

    let options = {
                    headers : {
                                  'Content-Type' : 'application/json'
                              },
                    params :  {
                                'id' : workflowRequestNum
                              },
                  };
  

      let dbResponse = await this.http.get(environment.workflowUrlGetRequest + environment.org, options)
                                      .toPromise();
      return dbResponse;
  }



  private handleError(error: any): Promise<any> {
    console.error('An error occurred ', error);
    console.error('Error in JSON ', JSON.stringify(error));
    return Promise.reject(error.message || error);
  }  

}

